import { createBrowserRouter, Navigate } from 'react-router';
import { AdminLayout } from './components/AdminLayout';
import { RequireAuth } from './components/RequireAuth';
import { PublicFormPage } from './features/form/PublicFormPage';
import { LinkDetailPage } from './features/links/LinkDetailPage';
import { LinksPage } from './features/links/LinksPage';
import { TemplateEditorPage } from './features/templates/TemplateEditorPage';
import { TemplatePreviewPage } from './features/templates/TemplatePreviewPage';
import { TemplatesPage } from './features/templates/TemplatesPage';
import { LoginPage } from './pages/LoginPage';
import { NotFoundPage } from './pages/NotFoundPage';

export const router = createBrowserRouter([
  { path: '/', element: <Navigate to="/admin" replace /> },
  { path: '/login', element: <LoginPage /> },

  // Public: the personal link a client receives.
  { path: '/f/:slug', element: <PublicFormPage /> },

  // Admin area (login required).
  {
    element: <RequireAuth />,
    children: [
      { path: '/admin/templates/:id/preview', element: <TemplatePreviewPage /> },
      {
        path: '/admin',
        element: <AdminLayout />,
        children: [
          { index: true, element: <Navigate to="/admin/links" replace /> },
          { path: 'links', element: <LinksPage /> },
          { path: 'links/:id', element: <LinkDetailPage /> },
          { path: 'templates', element: <TemplatesPage /> },
          { path: 'templates/:id', element: <TemplateEditorPage /> },
        ],
      },
    ],
  },

  { path: '*', element: <NotFoundPage /> },
]);
